import {getInterests} from "@/api/list";
import {IList} from "@/interfaces";
import {useEffect, useState} from "react";

export const useInterestList = () => {
	const [interestList, setInterestList] = useState<IList[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		setLoading(true);
		getInterests()
			.then((response) => {
				setInterestList(response.data);
				setError(null);
			})
			.catch((err) => {
				setError(err);
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	return {interestList, loading, error};
}
